import { useEffect, useState } from "react";
import { collection, getDocs, addDoc } from "firebase/firestore";
import { db } from "../firebase";
import { Link } from "react-router-dom";
import { sendEmail } from "../components/sendemail";

export default function TutoringProgram() {
  const [tutors, setTutors] = useState([]);
  const [filter, setFilter] = useState("");
  const [gradeFilter, setGradeFilter] = useState("");
  const [email, setEmail] = useState("");
  const [showWaitlist, setShowWaitlist] = useState(false);
  const [waitlistSuccess, setWaitlistSuccess] = useState(false);
  const [form, setForm] = useState({
    name: "",
    email: "",
    grade: "",
    subjects: "",
    availability: "",
    notes: ""
  });

  useEffect(() => {
    const fetchTutors = async () => {
      const snap = await getDocs(collection(db, "users"));
      setTutors(
        snap.docs
          .map(d => ({ uid: d.id, ...d.data() }))
          .filter(t => t.status === "approved" && !t.atCapacity)
      );
    };
    fetchTutors();
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const submitWaitlist = async () => {
    try {
      await addDoc(collection(db, "waitlist"), {
        name: form.name,
        email: form.email,
        grade: form.grade,
        subjects: form.subjects,
        availability: form.availability,
        notes: form.notes,
        createdAt: new Date()
      });

      await sendEmail(
        form.email,
        "Welcome to the SOWS Tutoring Waitlist!",
        `<p>Hello ${form.name}!</p>
        <p>Thank you for your interest in participating in the SOWS Fund tutoring program as a student. We're excited to welcome you to an organization dedicated to supporting our local communities while helping Gazan students pursue higher education around the world. Your service will go a long way!</p>
        <p><strong>Our goal is simple: "Supporting Education through Education"</strong></p>
        <p>At the moment, you have been placed on our waitlist as we finalize tutor availability. As soon as a tutor is available, we will reach out to you right away with the next steps. We appreciate your patience and are looking forward to working with you very soon!</p>
        <p>Please feel free to share any questions, comments, or concerns with us at: <a href="mailto:sowstutoring@leonardeducation.org">sowstutoring@leonardeducation.org</a>.</p>
        <p>With Gratitude,<br/>SOWS</p>`
      );

      setWaitlistSuccess(true);
      setTimeout(() => {
        setShowWaitlist(false);
        setWaitlistSuccess(false);
        setForm({
          name: "",
          email: "",
          grade: "",
          subjects: "",
          availability: "",
          notes: ""
        });
      }, 5000);
    } catch (error) {
      console.error("Error saving to Firestore:", error);
    }
  };

  const subscribe = async () => {
    if (!email) return;
    await addDoc(collection(db, "subscribers"), { email });
    setEmail("");
    alert("Subscribed!");
  };

  const filtered = tutors.filter(t => {
    const subjectMatch = filter ? t.subjects?.includes(filter) : true;
    const gradeMatch = gradeFilter ? t.gradeLevels?.includes(gradeFilter) : true;
    return subjectMatch && gradeMatch;
  });

  return (
    <>
      {/* HERO */}
      <div className="hero">
        <h1>Supporting Education Through Education</h1>
        <p>
          SOWS is the only tutoring service that funds scholarships for Gazan students.
          Want to be part of the change? Apply to be a tutor now!
        </p>
        <div className="nav-buttons">
          <Link to="/register" className="pink-btn">Become a Tutor!</Link>
          <Link to="/login" className="pink-outline">Tutor Log in</Link>
        </div>
      </div>

      {/* SUBJECT FILTERS */}
      <h2 style={{ textAlign: "center", fontSize: "40px", marginTop: "60px", color: "#f6f0dc" }}>
        Search for tutors by subject!
      </h2>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr auto",
          alignItems: "center",
          gap: "16px"
        }}
      >
        <div className="subjects" style={{ minWidth: 0 }}>
          <span className="subject-filter" onClick={() => setFilter("")}>All</span>
          <span className="subject-filter" onClick={() => setFilter("English")}>English</span>
          <span className="subject-filter" onClick={() => setFilter("Math")}>Math</span>
          <span className="subject-filter" onClick={() => setFilter("Biology")}>Biology</span>
          <span className="subject-filter" onClick={() => setFilter("Chemistry")}>Chemistry</span>
          <span className="subject-filter" onClick={() => setFilter("Physics")}>Physics</span>
          <span className="subject-filter" onClick={() => setFilter("Standardized Tests")}>Standardized Tests</span>
          <span className="subject-filter" onClick={() => setFilter("Applications")}>Applications</span>
        </div>

        {/* Grade level filter — a small dropdown pinned to its own grid column so it can't get pushed below the subject pills */}
        <div className="grade-filter">
          <label htmlFor="gradeFilter" className="grade-filter-label">
            Grade level
          </label>
          <select
            id="gradeFilter"
            className="grade-filter-select"
            value={gradeFilter}
            onChange={(e) => setGradeFilter(e.target.value)}
          >
            <option value="">All</option>
            <option value="Elementary School">Elementary School</option>
            <option value="Middle School">Middle School</option>
            <option value="High School">High School</option>
            <option value="College">College</option>
          </select>
        </div>
      </div>

      {/* TUTOR GRID, or a generic waitlist prompt when the selected filters have no matches */}
      {filtered.length > 0 ? (
        <div className="tutor-grid">
          {filtered.map(t => (
            <div key={t.uid} className="tutor-card">
              <h3>{t.name}</h3>
              <p>
                {t.subjects?.map((sub, i) => (
                  <span key={i} className="subject">
                    {sub}{i < t.subjects.length - 1 && ", "}
                  </span>
                ))}
              </p>
              {t.gradeLevels && t.gradeLevels.length > 0 && (
                <p style={{ fontSize: "14px", color: "#2d3d12", fontWeight: "600" }}>
                  {t.gradeLevels.join(", ")}
                </p>
              )}
              <Link to={`/tutors/${t.uid}`}>View full profile</Link>
            </div>
          ))}
        </div>
      ) : (
        <div style={{ textAlign: "center", margin: "60px 0" }}>
          <h2 style={{ fontSize: "36px", color: "#f6f0dc", marginBottom: "16px" }}>
            No tutors currently match your filters
          </h2>
          <p style={{ fontSize: "20px", color: "#f6f0dc", marginBottom: "24px" }}>
            Join our student waitlist and we'll reach out as soon as a tutor becomes available!
          </p>
          <button
            className="pink-btn"
            style={{ fontSize: "20px", padding: "16px 40px", border: "none", cursor: "pointer" }}
            onClick={() => setShowWaitlist(true)}
          >
            Student Waitlist
          </button>
        </div>
      )}

      {/* WAITLIST POPUP */}
      {showWaitlist && (
        <div className="request-overlay" onClick={() => setShowWaitlist(false)}>
          <div className="request-box" onClick={(e) => e.stopPropagation()}>
            <h2>Join the Waitlist</h2>
            <input name="name" placeholder="Student Name" value={form.name} onChange={handleChange} />
            <input name="email" placeholder="Email Address" value={form.email} onChange={handleChange} />
            <input name="grade" placeholder="Grade Level" value={form.grade} onChange={handleChange} />
            <input name="subjects" placeholder="Subjects Needed" value={form.subjects} onChange={handleChange} />
            <input name="availability" placeholder="Preferred Times" value={form.availability} onChange={handleChange} />
            <textarea name="notes" placeholder="Additional Notes" rows="4" value={form.notes} onChange={handleChange} />
            <button onClick={submitWaitlist}>Join Waitlist</button>
            {waitlistSuccess && (
              <p className="waitlist-success">
                You've been added to the waitlist! You will be contacted as soon as a tutor becomes available!
              </p>
            )}
          </div>
        </div>
      )}
    </>
  );
}
